import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import './calendar.css';
import { Icon } from '../../../ui/src/component/icon';

class Calendar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: moment(),
      currentDay: moment(),
      daysOfMonth: moment().daysInMonth(),
      firstDay: moment().startOf('month'),
      days: [],
      offsetOfDays: null,
    };

    this.renderDays = this.renderDays.bind(this);
    this.renderEmptyCells = this.renderEmptyCells.bind(this);
    this.createEmptyCells = this.createEmptyCells.bind(this);
    this.renderHeader = this.renderHeader.bind(this);

    this.handleChangeNextMonth = this.handleChangeNextMonth.bind(this);
    this.handleChangePrevMonth = this.handleChangePrevMonth.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.generateDates = this.generateDates.bind(this);
  }

  componentDidMount() {
    const { date } = this.props;
    this.setState(
      {
        selectedDate: moment(date),
      },
      () => {
        this.generateDates(date);
      },
    );
  }

  componentWillReceiveProps(nextProps) {
    const { date } = this.props;
    const { date: nextDate } = nextProps;
    if (date !== nextDate) {
      this.setState(
        {
          selectedDate: moment(nextDate),
        },
        () => {
          this.generateDates(nextDate);
        },
      );
    }
  }

  generateDates(date) {
    this.setState(
      {
        firstDay: moment(date).startOf('month'),
        daysOfMonth: moment(date).daysInMonth(),
      },
      () => {
        const { firstDay } = this.state;
        let arr = [];
        for (let i = 0; i < this.state.daysOfMonth; i += 1) {
          arr.push(
            firstDay
              .clone()
              .add(i, 'day')
              .format('YYYY-MM-DD'),
          );
        }
        this.setState({
          days: arr,
        });
        this.createEmptyCells();
      },
    );
  }

  createEmptyCells() {
    const { firstDay } = this.state;
    const first = firstDay.day();
    let array = [];
    for (let i = 0; i < (first > 0 ? first - 1 : 6); i += 1) {
      array.push(i);
    }
    this.setState({
      offsetOfDays: array,
    });
  }

  renderHeader(day, idx) {
    if (idx === 5 || idx === 6) {
      return (
        <div className="day name-of-day freeDay" key={day}>
          {day}
        </div>
      );
    }
    return (
      <div className="day name-of-day" key={day}>
        {day}
      </div>
    );
  }

  renderDays(day, i) {
    const { selectedDate } = this.state;
    const dayIdx = moment(day).isoWeekday();
    if (dayIdx === 6 || dayIdx === 7) {
      return (
        <div
          className="day freeDay"
          key={day}
          onClick={() => this.handleClick(day)}
        >
          {selectedDate._i === day ? (
            <div className="current-day">{i + 1}</div>
          ) : (
            i + 1
          )}
        </div>
      );
    }
    return (
      <div className="day" key={day} onClick={() => this.handleClick(day)}>
        {selectedDate._i === day ? (
          <div className="current-day">{i + 1}</div>
        ) : (
          i + 1
        )}
      </div>
    );
  }

  renderEmptyCells(day) {
    return <div className="empty-day" key={day} />;
  }

  handleClick(day) {
    this.props.onClick(day);
  }

  handleChangeNextMonth() {
    const { selectedDate } = this.state;
    let newDate = selectedDate;
    newDate.add(1, 'months');
    this.generateDates(newDate.format('YYYY-MM-DD'));
  }

  handleChangePrevMonth() {
    const { selectedDate } = this.state;
    let newDate = selectedDate;
    newDate.subtract(1, 'months');
    this.generateDates(newDate.format('YYYY-MM-DD'));
  }

  render() {
    const { days, selectedDate, offsetOfDays } = this.state;
    const header = ['Po', 'Ut', 'St', 'Št', 'Pi', 'So', 'Ne'];
    return (
      <div className="callendar">
        <div className="month-controller">
          <div>
            <span className="selected-month">
              {selectedDate.format('MMMM YYYY')}
            </span>
          </div>
          <div className="change-month">
            <button
              className="custom-button"
              onClick={this.handleChangePrevMonth}
            >
              <Icon
                name="chevron-circle-right"
                className="icon-md calendar-icon"
              />
            </button>
            {'  '}
            <button
              className="custom-button"
              onClick={this.handleChangeNextMonth}
            >
              <Icon
                name="chevron-circle-right"
                className="icon-md calendar-icon"
              />
            </button>
          </div>
        </div>
        <div className="days">
          {header.map(this.renderHeader)}
          {offsetOfDays && offsetOfDays.map(this.renderEmptyCells)}
          {days && days.map(this.renderDays)}
        </div>
      </div>
    );
  }
}

Calendar.propTypes = {
  date: PropTypes.string,
  onClick: PropTypes.func,
};

Calendar.defaultProps = {
  date: moment().format('YYYY-MM-DD'),
  onClick: () => {},
};

export default Calendar;



// WEBPACK FOOTER //
// ./src/app/component/Calendar/index.js